import { connect } from "react-redux";

import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { AbsoluteModelPath, ModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { IterUtils } from "../../../../../Common/IterableUtils";

import { FIO, nameSuffix, surnameSuffix, patronymicSuffix } from "./FIO";

const pathSuffixes: ModelPath[] = [surnameSuffix, nameSuffix, patronymicSuffix];

export interface FIOContainerProps {
    pathPrefix: AbsoluteModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: FIOContainerProps) => {
    const { viewModelSelect } = ownProps;
    const error = IterUtils.first(
        Iterator.from(pathSuffixes)
            .map(suffix => ownProps.pathPrefix.joinWith(suffix))
            .map(path => viewModelSelect.controlModel(state, path).error)
            .filter(isNotNullOrUndefined)
    );
    return {
        error: error,
        isReadOnly: state.settings.isReadOnly,
    };
};

export const FIOContainer = withViewModelSelect(
    connect(mapStateToProps)(withFocusManagement(FIO, x => [x.pathPrefix.toLegacyPath()]))
);
